import { ExtendedNextLink } from 'components/Basic/ExtendedNextLink/ExtendedNextLink';
import { NotImplementedYetHandler } from 'components/Helpers/NotImplementedYet';
import { QuickContactWrapper } from 'components/Layout/Header/HeaderBottom/UserMenu/B2b/QuickContactWrapper';
import { MenuItemProps } from 'components/Layout/Header/HeaderBottom/UserMenu/UserMenu';
import { useAuth } from 'hooks/auth/useAuth';
import { useCurrentUserData } from 'hooks/user/useCurrentUserData';
import useTranslation from 'next-translate/useTranslation';
import { forwardRef } from 'react';
import { twJoin } from 'tailwind-merge';

type UserMenuDesktopProps = {
    menuItems: MenuItemProps[];
    isActive: boolean;
};

const TEST_IDENTIFIER = 'header-user-menu-sub';

const UserMenuDesktop = forwardRef<HTMLUListElement, UserMenuDesktopProps>(({ menuItems, isActive }, ref) => {
    const { t } = useTranslation();
    const { logout } = useAuth();
    const { user } = useCurrentUserData();

    return (
        <ul
            ref={ref}
            className={twJoin(
                'absolute left-0 top-full z-menu mt-2 block min-w-[150px] origin-top-right overflow-hidden rounded-md font-medium tracking-wide shadow-mobileSubMenu transition-all will-change-transform',
                isActive
                    ? 'pointer-events-auto scale-100 opacity-100'
                    : 'pointer-events-none scale-x-75 scale-y-50 opacity-0',
            )}
        >
            {menuItems
                .filter((menuItem) => menuItem.show)
                .map((menuItem, index) => {
                    if (menuItem.link === null) {
                        return (
                            <li
                                key={menuItem.title}
                                className="block border-t border-grayMidDarker first:border-t-0"
                                data-testid={`${TEST_IDENTIFIER}-${index}`}
                                onClick={NotImplementedYetHandler}
                            >
                                <a className="block bg-white px-4 py-3.5 text-primary no-underline" tabIndex={0}>
                                    {menuItem.title}
                                </a>
                            </li>
                        );
                    }

                    return (
                        <li
                            key={menuItem.title}
                            className="block border-t border-grayMidDarker first:border-t-0"
                            data-testid={`${TEST_IDENTIFIER}-${index}`}
                        >
                            <ExtendedNextLink
                                className="block bg-white px-4 py-3.5 text-primary no-underline"
                                href={menuItem.link}
                            >
                                {menuItem.title}
                            </ExtendedNextLink>
                        </li>
                    );
                })}
            <li className="block border-t border-grayMidDarker first:border-t-0" data-testid={`${TEST_IDENTIFIER}-8`}>
                <a
                    className="block bg-grayLighter px-4 py-3.5 text-primary no-underline"
                    data-testid={TEST_IDENTIFIER}
                    tabIndex={0}
                    onClick={logout}
                >
                    <span className="whitespace-nowrap">
                        {t('Logout')} {user?.firstName} {user?.lastName}
                    </span>
                </a>
            </li>
            <QuickContactWrapper
                manager={user?.defaultDeliveryAddress?.manager ?? null}
                quickContact={user?.quickContact ?? null}
                type="menu-desktop"
            />
        </ul>
    );
});

UserMenuDesktop.displayName = 'UserMenuDesktop';

export default UserMenuDesktop;
